export const INJECTION_PRODUCT_PAGE = Symbol('exped_product_page_product')
